<template>
  <div id="basic-master">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center mb-base">
        <div class="flex-grow">
          <div class="upper-controller">
            <template v-if="!isEditingOrder">
              <p>検索</p>
              <vs-input
                class="search-input"
                color="#2D9CDB"
                v-model="searchInput"
                placeholder="キーワードを入力"
                @keydown.enter="searchInputEnter"
              >
              </vs-input>
              <vs-button
                class="search-button"
                v-if="!incrementSearch"
                color="#2D9CDB"
                @click="callSearch"
              >
              検索
              </vs-button>
              <div
                class="display-items"
                v-if="pagination"
              >
                <span>表示数</span>
                <v-select
                  class="display-items-select-box"
                  v-model="displayItemsTemp"
                  :options="displayItemsOptions"
                  label="number"
                  placeholder="選択してください"
                  :clearable="false"
                  :searchable="false"
                >
                  <template #selected-option="{}">
                    <div style="display: flex; align-items: baseline;">
                      {{displayItemsText}}
                    </div>
                  </template>
                </v-select>
              </div>
              <vs-button
                class="add-button top-button"
                color="#2D9CDB"
                v-if="insertDataPageName"
                @click="toInsertPage"
              >
                <div class="button-inner">
                  <feather-icon class="mr-2" icon="PlusIcon" svgClasses="h-5 w-5" />
                  <span>新規登録</span>
                </div>
              </vs-button>
              <div v-else class="add-button blank">
              </div>
              <vs-button
                class="order-button top-button border-button"
                color="#ffffff"
                @click="clickChangeOrder"
                v-if="sortable"
              >
                <div class="button-inner">
                  <feather-icon class="mr-2" icon="ListIcon" svgClasses="h-5 w-5" />
                  <span>表示順序変更</span>
                </div>
              </vs-button>
            </template>
            <template v-else>
              <span class="title">表示順序変更</span>
              <vs-button
                class="order-cancel-button top-button"
                @click="cancelEditOrder"
                color="#BDBDBD"
              >
                <div class="button-inner">
                  <span>キャンセル</span>
                </div>
              </vs-button>
              <vs-button
                class="order-save-button top-button"
                color="#2D9CDB"
                @click="callUpdateOrder"
              >
                <div class="button-inner">
                  <span>保存</span>
                </div>
              </vs-button>

            </template>
          </div>
          <div class="table-area">
            <div class="header row">
              <div
                class="cell index"
              >
              </div>
              <template v-for="(column) in columns">
                <div class="cell" :class="generateClassses(column)" :key="column.key">
                  {{ column.displayName }}
                </div>
              </template>
            </div>
            <draggable
              v-model="filteredData"
              :disabled="!isEditingOrder"
              @start="drag=true"
              @end="drag=false"
              v-bind="dragOptions"
            >
               <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                <div class="content-row row"
                  :class="{
                    'focused': isEditingId == rowData.id,
                    'ordered': isEditingOrder,
                    'dragged': drag,
                  }"
                  v-for="(rowData, index) in filteredData"
                  :key="rowData.id"
                >
                  <span 
                    @click="clickRow(rowData.id)"
                    class="main-columns"
                    :class="{'clickable': !isEditingOrder}"
                  >
                    <div class="index cell">
                      {{pagination && !isEditingOrder ? indexFrom + index : index + 1}}
                    </div>
                    <template v-for="(column) in columns">
                      <editable-color-cell
                        v-if="column.inputType == 'color'"
                        class="cell"
                        :class="column.key"
                        :isEditing="isEditingId == rowData.id"
                        :color="rowData[column.key]"
                        @updateValue="updateValue(column.key, rowData.id, $event)"
                        :colorOptions="colorOptions"
                        :key="column.key"
                      >
                      </editable-color-cell>

                      <editable-string-cell
                        v-else-if="column.inputType == 'string'"
                        class="cell"
                        :class="generateClassses(column)"
                        :isEditing="isEditingId == rowData.id"
                        @updateValue="updateValue(column.key, rowData.id, $event)"
                        :string="rowData[column.key]"
                        :key="column.key"
                      >
                      </editable-string-cell>

                      <editable-select-cell
                        v-else-if="column.inputType == 'select'"
                        class="cell"
                        :class="column.key"
                        :isEditing="isEditingId == rowData.id"
                        :selectOptions="column.selectOptions"
                        @updateValue="updateValue(column.key, rowData.id, $event)"
                        :value="String(rowData[column.key])"
                        :key="column.key"
                      >
                      </editable-select-cell>

                      <tag-cell
                        v-else-if="column.inputType == 'tag'"
                        class="cell"
                        :class="column.key"
                        :tags="rowData[column.key]"
                        :key="column.key"
                      >
                      </tag-cell>

                      <editable-text-area-cell
                        v-else-if="column.inputType == 'textArea'"
                        class="cell"
                        :class="column.key"
                        :isEditing="isEditingId == rowData.id"
                        @updateValue="updateValue(column.key, rowData.id, $event)"
                        :string="rowData[column.key]"
                        :key="column.key"
                      >
                      </editable-text-area-cell>
                    </template>
                  </span>
                  <vs-dropdown class="more-button" color="#2D9CDB" :vs-trigger-click="true" v-if="!isEditingOrder && isEditingId != rowData.id">
                    <feather-icon class="mr-2" icon="MoreVerticalIcon" svgClasses="h-5 w-5" />
                    <vs-dropdown-menu class="more-button-dropdown">
                      <vs-dropdown-item @click="openDeletePopup(rowData)">
                        <span class="flex items-center">
                          <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                          <span>削除</span>
                        </span>
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                  
                  <div class="cell function" v-if="isEditingId == rowData.id">
                    <template >
                      <vs-button class="control-button" color="#BDBDBD" @click.native="cancelEdit">キャンセル</vs-button>
                      <vs-button class="control-button" color="#2D9CDB" @click.native="callSave" :disabled="!dataChanged">保存</vs-button>
                    </template>
                  </div>
                </div>
              </transition-group>
            </draggable>
          </div>

          <vs-pagination
            class="master-pagination"
            v-if="pagination && !isEditingOrder"
            :total="totalPages"
            :max="5"
            v-model="currentPageTemp"
            color="#2D9CDB"
          />

          <vs-popup class="basic-master-popup"  :title="masterName + 'の削除'" :active.sync="popupActive">
            <p>
              「{{deleteTarget.displayName}}」を削除してよろしいですか？
            </p>
            <div class="button-area">
              <vs-button class="popup-button" color="#BDBDBD" @click="closeDeletePopup">キャンセル</vs-button>
              <vs-button class="popup-button" color="#2D9CDB" @click="callDelete(deleteTarget.id)">削除</vs-button>
            </div>
          </vs-popup>
          
        </div>
      </div>
    </div>
    <error-dialog
      ref="errorDialog"
    ></error-dialog>
  </div>
</template>

<script>

import EditableStringCell from "./EditableStringCell";
import EditableColorCell from "./EditableColorCell";
import EditableSelectCell from "./EditableSelectCell";
import EditableTextAreaCell from "./EditableTextAreaCell";
import ErrorDialog from "./ErrorDialog";
import TagCell from "./TagCell";
import vSelect from 'vue-select'
import draggable from 'vuedraggable'
import _ from "lodash";

export default {
  components: {
    EditableStringCell,
    EditableColorCell,
    EditableSelectCell,
    EditableTextAreaCell,
    TagCell,
    draggable,
    vSelect,
    ErrorDialog
  },
  props: {
    data: { type: Array },
    columns: { type: Array },
    masterName: { type: String },
    colorOptions: { type: Array },
    insertDataPageName: { type: String },
    selectOptions: { type: Object },
    pagination: { type: Boolean, default: false },
    totalPages: { type: Number },
    totalItems: { type: Number },
    currentPage: { type: Number },
    incrementSearch: { type: Boolean, default: true },
    sortable: { type: Boolean, default: true },
    editable: { type: Boolean, default: true },
    viewPageName: { type: String },
    displayItems: { type: Object },
    storedSearchKeyword: { type: String, default: "" },
  },
  data() {
    return {
      drag: false,
      searchInput: this.storedSearchKeyword,
      isEditingId: "",
      isEditingOrder: false,
      inputData: [],
      receivedData: [],
      filteredData: [],
      popupActive: false,
      currentPageTemp: this.currentPage,
      isForcedChangeCurrentPage: false,
      deleteTarget: {
        id: "",
        displayName: ""
      },
      displayItemsOptions: [
        {
          number: 10
        },
        {
          number: 20
        },
        {
          number: 30
        },
      ],
      displayItemsTemp: this.displayItems,
      lastSearchCondition: {}
    };
  },
  created() {
    // initialize attributes
    this.currentPageTemp++
  },
  watch: {
    data(value) {
      this.receivedData = JSON.parse(JSON.stringify(value))

      this.inputData.splice(0)
      value.forEach((data) => {
        this.inputData.push(data)
      })

      this.filteredData = JSON.parse(JSON.stringify(value))
    },
    searchInput() {
      if (this.incrementSearch) {
        this.callSearch()
      }
    },
    currentPageTemp(value) {
      if (!this.isForcedChangeCurrentPage && this.pagination) {
        let searchCondition = {
          limit: this.displayItems.number,
          page: value - 1,
        }

        this.lastSearchCondition = { ...searchCondition, name: this.storedSearchKeyword }
        this.$emit("callSearch", searchCondition)
      }
    },
    displayItemsTemp: {
      handler() {
        this.$emit("updateDisplayItems", this.displayItemsTemp)
        let searchCondition = {
          limit: this.displayItemsTemp.number,
          page: 0,
        }
        this.isForcedChangeCurrentPage = true
        this.currentPageTemp = 1
        this.isForcedChangeCurrentPage = false
        
        this.lastSearchCondition = { ...searchCondition, name: this.storedSearchKeyword }
        this.$emit("callSearch", searchCondition)
      },
      deep: true,
    },
  },
  computed: {
    displayItemsText() {
      let from = this.receivedData.length != 0 ? this.currentPage * this.displayItemsTemp.number + 1 : 0
      let to = this.currentPage * this.displayItemsTemp.number + this.receivedData.length
      let total = this.totalItems
      return `${from}-${to}/${total}`
    },
    indexFrom() {
      return this.receivedData.length != 0 ? this.currentPage * this.displayItemsTemp.number + 1 : 0
    },
    dataChanged() {
      return !_.isEqual(this.inputData, this.receivedData)
    },
    searchKeys() {
      return this.columns.filter(column => column.searchable).map(filteredColumns => filteredColumns.key)
    },
    dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  methods: {
    callSearch() {
      if (this.incrementSearch) {
        this.cancelEdit()
        this.filteredData = this.receivedData.filter(element => {
          return this.searchKeys.some(key => element[key] ? element[key].includes(this.searchInput) : false)
        })
      } else {
        let searchCondition = {
          keyword: this.searchInput,
          limit: this.displayItems.number,
          page: 0,
        }
        this.isForcedChangeCurrentPage = true
        this.currentPageTemp = 1
        this.isForcedChangeCurrentPage = false

        this.lastSearchCondition = { ...searchCondition, name: this.storedSearchKeyword }
        this.$emit("callSearch", searchCondition)
      }
    },
    searchInputEnter(event) {
      if (event.keyCode !== 13 || this.incrementSearch) return
      this.callSearch()
    },
    clickRow(id) {
      if (this.isEditingOrder) return
      if (this.editable && id != this.isEditingId) {
        this.cancelEdit()
        this.isEditingId = id
      } else {
        this.toViewPage(id)
      }
    },
    callSave() {
      let editedRowData = this.inputData[this.inputData.findIndex(element => element.id == this.isEditingId)]
      this.$emit("callSave", editedRowData)
      this.isEditingId = ""
    },
    callDelete(id) {
      if (this.pagination) {
        this.isForcedChangeCurrentPage = true
        this.currentPageTemp = 1
        this.isForcedChangeCurrentPage = false
      }
      this.popupActive = false
      this.$emit("callDelete", id)
    },
    callUpdateOrder() {
      this.isEditingOrder = false
      let sortOrders = this.filteredData.map((rowData, index) => {
        return {
          id: rowData.id,
          sort_order: index,
        }
      })
      this.$emit("callUpdateOrder", sortOrders)
    },
    forceUpdateTable(value) {
      this.searchInput = ""
      this.filteredData = value
      this.inputData.splice(0)
      JSON.parse(JSON.stringify(this.receivedData)).forEach((data) => {
        this.inputData.push(data)
      })
    },
    setCurrentPageTemp(value) {
      this.currentPageTemp = value
    },
    cancelEdit() {
      this.isEditingId = ''
      this.inputData.splice(0)
      JSON.parse(JSON.stringify(this.receivedData)).forEach((data) => {
        this.inputData.push(data)
      })
    },
    cancelEditOrder() {
      if (!this.pagination) {
        this.isEditingOrder = ''
        this.filteredData = this.receivedData
      } else {
        this.isEditingOrder = ''
        this.callSearch()
      }
    },
    updateValue(key, id, value) {
      if (this.isEditingId == id) {
        this.inputData[this.inputData.findIndex(element => element.id == this.isEditingId)][key] = value
      }
    },
    clickChangeOrder() {
      if (!this.pagination) {
        this.isEditingOrder = true
        this.isEditingId = ''
        this.searchInput = ''
        this.filteredData = this.receivedData
      } else {
        this.isEditingOrder = true
        this.$emit("callFetchAll")
      }
    },
    openDeletePopup(rowData) {
      this.deleteTarget = {
        id: rowData.id,
        displayName: rowData[this.columns[0].key],
      }
      this.popupActive = true
    },
    openErrorPopup(title, errorMessage, validationErrors) {
      this.$refs.errorDialog.open(title, errorMessage, validationErrors)
    },
    closeDeletePopup() {
      this.popupActive = false
    },
    toViewPage(id) {
      if (!this.editable) {
        this.$router.push({
          name: this.viewPageName,
          params: { itemId: id, lastSearchCondition: this.lastSearchCondition}
        })
      }
    },
    toInsertPage() {
      this.$router.push({
        name: this.insertDataPageName
      })
    },
    generateClassses(columnData) {
      let classObj = {}
      classObj[columnData.key] = true
      if (Object.prototype.hasOwnProperty.call(columnData, "cellClass")){
        classObj[columnData.cellClass] = true
      }
      return classObj
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
#basic-master {
  .flip-list-move {
    transition: transform 0.5s;
  }
  .no-move {
    transition: transform 0s;
  }
  .ghost {
    opacity: 0.5;
    background: $pm-super-light-blue;
  }

  .title {
    font-size: 18px;
  }
  .upper-controller {
    display: flex;
    align-items: center;
    margin-bottom: 40px;
  }
  .display-items-select-box {
    margin-left: 10px;
    width: 145px;
    .vs__search {
      padding: 0px;
    }
  }
  .display-items {
    display: flex;
    align-items: center;
    margin-left: 20px;
  }
  .add-button, .order-cancel-button {
    margin-left: auto;
    margin-right: 20px;
  }
  .top-button {
    height: 42px;
  }
  .border-button {
    border: solid 1px $pm-blue;
    .button-inner {
      color: $pm-blue;
      line-height: 1;
    }
  }
  .button-inner {
    display: flex;
    align-items: center;
  }
  .search-input {
    margin: 0px 10px;
  }
  .header {
    font-weight: bold;
  }
  .row {
    min-height: 53px;
    height: fit-content;
    display: flex;
    border-bottom: solid 1px $pm-light-white;
  }
  .content-row {
    justify-content: space-between;
    transition: 0.3s;
    flex-wrap: wrap;
    position: relative;
    &:hover {
      background: $pm-white;
    }
  }
  .main-columns {
    display: flex;
    flex-grow: 1;
  }
  .cell {
    display: flex;
    margin-right: 10px;
    padding: 5px 10px;
    align-items: center;
    &.label {
      min-width: 170px;
      max-width: 170px;
    }
    &.mmsi {
      min-width: 130px;
      max-width: 130px;
    }
    &.imo {
      min-width: 130px;
      max-width: 130px;
    }
    &.call_sign {
      min-width: 110px;
      max-width: 110px;
    }
    &.vihecle {
      min-width: 100px;
      max-width: 100px;
    }
    &.short_name {
      min-width: 80px;
      max-width: 80px;
    }
    &.berth-short-name {
      min-width: 80px;
      max-width: 80px;
    }
    &.name {
      min-width: 170px;
      max-width: 170px;
    }
    &.agency-name {
      flex-grow: 1;
      min-width: initial !important;
      max-width: initial !important;
    }
    &.kana {
      min-width: 170px;
      max-width: 170px;
    }
    &.name_en {
      flex-grow: 1;
      min-width: initial;
      max-width: 170px;
    }
    &.code {
      min-width: 120px;
      max-width: 120px;
    }
    &.admin_code {
      min-width: 130px;
      max-width: 130px;
    }
    &.tel {
      min-width: 130px;
      max-width: 130px;
    }
    &.rank {
      min-width: 150px;
      max-width: 150px;
    }
    &.color {
      min-width: 210px;
      max-width: 210px;
    }
    &.description {
      max-width: 1000px;
    }
    &.billing_address {
      min-width: 120px;
      max-width: 120px;
    }
    &.ports {
      min-width: 120px;
      max-width: 120px;
    }
    &.tags {
      flex-wrap: wrap;
    }
    &.function {
      margin-left: 30px;
      margin-right: 0px;
    }
    &.index {
      font-weight: bold;
      min-width: 40px;
      max-width: 40px;
      margin-right: 0px;
    }
  }

  .vs-con-dropdown {
    position: absolute;
    right: 0;
    top: 32%;
  }
  
  .row.focused {
    background: $pm-white;
  }
  .main-columns.clickable {
    cursor: pointer;
  }
  .row.ordered:hover {
    cursor: grab !important;
  }
  .row.dragged:hover {
    cursor: move;
  }
  .control-button {
    margin-right: 10px;
    white-space: nowrap;
  }

  .master-pagination {
    margin-top: 20px;
  }

  .more-button:hover {
    cursor: pointer;
  }
}
.basic-master-popup {
  .popup-button {
    margin-left: 10px;
  }
  .button-area {
    width: fit-content;
    margin-top: 20px;
    margin-left: auto;
  }
}
.more-button-dropdown {
  width: 90px;
}

</style>